.patients {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.title {
  font-size: 28px;
}

.tools {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.empty {
  color: var(--ink-2);
}

.list {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: var(--surface);
  border: var(--outline);
  border-radius: var(--radius-card);
  box-shadow: var(--shadow-card);
}
